/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {SCORM} from 'pipwerks-scorm-api-wrapper';
import translate from './scormTranslate.json';

export default function Tracking(props) {

  const [connected, setConnected] = useState(false);

  const get = (key) => {
    key = translate[props.version][key];
    return SCORM.get(key);
  }

  const set = (key, val, autoCommit = false) => {
    //console.log('Tracking.set()');
    const translated = translate[props.version][key];
    if (translated !== undefined) {
      key = translated;
    }
    //console.log('Data save attempt', key, ':', val);

    SCORM.set(key, val);

    //console.log('Data save result:', SCORM.debug.getCode());
    if (autoCommit) {
      commit();
    }
    return SCORM.debug.getCode();
  }

  const commit = () => {
    //console.log('Data commit attempt');
    SCORM.save();
    //console.log('Data commit result:', SCORM.debug.getCode());
  }

  const getSuspendData = () => {
    const suspend = get('suspend_data');
    if (suspend == null || suspend === '' || suspend === undefined || suspend === 'null') {
      return false;
    }
    return JSON.parse(suspend);
  }

  useEffect(() => {
    console.log("TRACKING init")
    // code to run on component mount
    const success = SCORM.init();
    setConnected(success);
    if (!success) {
      console.log('TRACKING: SCORM init failure, halting')
      return;
    }
    const bookmark = {
      lessonLocation: get('lesson_location'),
      suspendData: getSuspendData()
    }
    props.onInit(bookmark)

    window.onbeforeunload = function () {
      SCORM.quit();
      // SCORM.save();
    }
  }, [])

  useEffect(() => {
    if (!connected) return;
    console.log("TRACKING index change detected")
    // code to run on component mount
    const bookmark = {
      stepIndex: props.stepIndex,
      moduleIndex: props.moduleIndex
    }
    set('lesson_location', JSON.stringify(bookmark))
    set('suspend_data', JSON.stringify(props.moduleProgress))
  }, [props.stepIndex, props.moduleIndex])

  useEffect(() => {
    if (!connected) return;

    if (props.scoComplete) {
      console.log("TRACKING course completion detected")
      set('lesson_status', translate[props.version]['complete']);
      if (props.scoScored) {
        if (props.version === 'scorm2004') {
          set('success_status', 'passed');
        } else {
          set('success_status', 'failed');
        }
      } else {
        set('success_status', 'passed');
      }
    }
    commit();

    // // hot fix 1/30/2019 - Orion
    // // just remove line below and uncomment code @ 209 in App.js to revert
    // window.top.close();

  }, [props.scoComplete])


  return (
    <div className="Tracking">

    </div>
  )
}
